// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-366b0912\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Badges.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("417adb64", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-366b0912\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Badges.vue", function() {
     var newContent = require("!!../../../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-366b0912\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Badges.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-366b0912","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Banners/Badges.vue
// module id = w0Cg
// module chunks = 0